import React from 'react'

const ChatHeader = () => {
    return (
        <div className='bg-bgColor-chat py-3 px-4 rounded-t-xl'>
            <img src={'/assets/admin/hotel-green-icon.svg'} className='object-contain h-[30px]' />
        </div>
    )
}

export default ChatHeader;